 <template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md4>
        <material-card
          color="orange"
          title="Safety Database - Forgot Password"
          text="Please insert your email"
        >
          <v-form ref="form" v-model="validForm" v-on:submit.prevent>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="forgotForm.email"
                    prepend-icon="mdi-account"
                    name="email"
                    label="Email"
                    type="text"
                    :rules="validators.email"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 text-xs-right>
                  <v-btn
                    color="orange"
                    class="mx-0 font-weight-light"
                    :disabled="!validForm"
                    @click="forgot"
                    >Send</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from "@/utils/validators";

export default {
  data: () => ({
    forgotForm: {
      email: ""
    },
    validForm: true,
    validators
  }),

  methods: {
    forgot(...args) {

      this.$store
        .dispatch("user/forgotPass", this.forgotForm)
        .then(() => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Please check your email to confirm that you want to reset your password!",
            color: "success"
          });
          this.$router.push({ path: "/login" });
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("app/openSnackbar", { message: e.response.data.message, color: 'red' });
          this.loading = false;
        });
    }
  }
};
</script>
